// BackToLearningCenterLink component to navigate back to the Learning Center
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { Button } from '@mui/material';
import React from 'react';
import { Link as RouterLink } from 'react-router-dom';

export function BackToLearningCenterLink(props) {
  return (
    <Button
      component={RouterLink}
      to={`/learn${props.subcategory ? `/${props.subcategory}` : ''}`}
      startIcon={<ArrowBackIcon />}
      sx={{ marginBottom: 2 }}
    >
      BACK TO {props.subcategory ? props.subcategory?.toUpperCase() : 'LEARNING CENTER'}
    </Button>
  );
}
